import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import LocationLoyaltyPerformanceApiDefinitions from './location-loyalty-performance-api-definitions/location-loyalty-performance-api-definitions.component';

type LocationLoyaltyPerformanceAPIDetailsDrawerProps = {
  isOpen: boolean;
  close: () => void;
};

const LocationLoyaltyPerformanceAPIDetailsDrawer = ({
  isOpen,
  close,
}: LocationLoyaltyPerformanceAPIDetailsDrawerProps) => {
  const { t } = useTranslation();
  return (
    <UtilityDrawer
      open={isOpen}
      onClose={close}
      title={t(
        'page.loyaltyPerformanceReport.tabs.locationLoyaltyPerformance.label',
      )}
    >
      <UtilityDrawerBody>
        <LocationLoyaltyPerformanceApiDefinitions />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default LocationLoyaltyPerformanceAPIDetailsDrawer;
